var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92874 3.99954V1.20954C7.92874 0.759542 7.38874 0.539542 7.07874 0.859542L3.27874 4.64954C3.07874 4.84954 3.07874 5.15954 3.27874 5.35954L7.06874 9.14954C7.38874 9.45954 7.92874 9.23954 7.92874 8.78954V5.99954C11.6587 5.99954 14.6087 9.41954 13.7887 13.2895C13.3187 15.5595 11.4787 17.3895 9.21874 17.8595C5.64874 18.6095 2.46874 16.1595 1.98874 12.8495C1.91874 12.3695 1.49874 11.9995 1.00874 11.9995C0.408739 11.9995 -0.0712611 12.5295 0.00873893 13.1295C0.628739 17.5195 4.80874 20.7695 9.53874 19.8495C12.6587 19.2395 15.1687 16.7295 15.7787 13.6095C16.7687 8.47954 12.8687 3.99954 7.92874 3.99954Z",
    fill: "#6D0FA7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.81ab75d6096ad3240ad25c91cb58bcf1.svg";
export { ForwardRef as ReactComponent };